var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgRecruitStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.918,
    height: 19.959,
    viewBox: "0 0 15.918 19.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.437,12.47a.309.309,0,0,0,.309-.309v-.99a1.7,1.7,0,0,0-.91-1.5V1.334a.309.309,0,0,0-.309-.309h-.775V.309A.309.309,0,0,0,65.444,0H55.549a.309.309,0,0,0,0,.618h9.586V9.472H59.856a1.076,1.076,0,0,1-1.007-.686l-.274-.7A1.69,1.69,0,0,0,56.993,7.01H53.7V.618h.822a.309.309,0,1,0,0-.618H53.389a.309.309,0,0,0-.309.309V7.07a1.7,1.7,0,0,0-1.252,1.639v9.679a1.572,1.572,0,0,0,1.57,1.57H66.176a1.572,1.572,0,0,0,1.571-1.57v-5.2a.309.309,0,0,0-.618,0v5.2a.954.954,0,0,1-.953.953H53.4a.954.954,0,0,1-.953-.953V8.709a1.083,1.083,0,0,1,1.082-1.082h3.465A1.076,1.076,0,0,1,58,8.314l.274.7a1.69,1.69,0,0,0,1.582,1.078h6.191a1.083,1.083,0,0,1,1.082,1.082v.99A.309.309,0,0,0,67.437,12.47ZM66.219,9.48a1.711,1.711,0,0,0-.172-.009h-.294V1.643h.466Z",
    transform: "translate(-51.828)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.979 1.691)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.857,46.362a1.649,1.649,0,1,0-1.918,0,1.647,1.647,0,0,0-.69,1.34.309.309,0,1,0,.618,0,1.031,1.031,0,0,1,2.062,0,.309.309,0,1,0,.618,0A1.647,1.647,0,0,0,130.857,46.362Zm-.959-.309a1.031,1.031,0,1,1,1.031-1.031A1.032,1.032,0,0,1,129.9,46.053Z",
    transform: "translate(-128.249 -43.373)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.051 2.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.292,53.194h-.656a.309.309,0,0,0,0,.618h.656a.309.309,0,0,0,0-.618Z",
    transform: "translate(-335.327 -53.194)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.42 2.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.075,53.194h-2.6a.309.309,0,1,0,0,.618h2.6a.309.309,0,1,0,0-.618Z",
    transform: "translate(-242.164 -53.194)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.42 8.122)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.76,208.351h-4.287a.309.309,0,1,0,0,.618h4.287a.309.309,0,1,0,0-.618Z",
    transform: "translate(-242.164 -208.351)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.507 6.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.222,169.562h-2.2a.309.309,0,1,0,0,.618h2.2a.309.309,0,1,0,0-.618Z",
    transform: "translate(-295.713 -169.562)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.42 6.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.531,169.562h-1.058a.309.309,0,1,0,0,.618h1.058a.309.309,0,0,0,0-.618Z",
    transform: "translate(-242.164 -169.562)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.42 3.586)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.76,91.982h-4.287a.309.309,0,1,0,0,.618h4.287a.309.309,0,0,0,0-.618Z",
    transform: "translate(-242.164 -91.982)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.42 5.098)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.76,130.773h-4.287a.309.309,0,1,0,0,.618h4.287a.309.309,0,1,0,0-.618Z",
    transform: "translate(-242.164 -130.773)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitStep2);
export default __webpack_public_path__ + "static/media/recruit-step2.d97fc6051e11a1c4d5dd222a1e9a6d31.svg";
export { ForwardRef as ReactComponent };